/* global axios */

import ApiClient from 'dashboard/api/ApiClient';

class ScheduledWorkflows extends ApiClient {
  constructor() {
    super('custom/scheduled_workflows', { accountScoped: true });
  }

  list(conversationId, { status } = {}) {
    return axios.get(this.url, {
      params: { conversation_id: conversationId, status },
    });
  }

  listPending(conversationId) {
    return this.list(conversationId, { status: 'pending' });
  }

  cancel(id) {
    return axios.delete(`${this.url}/${id}/cancel`);
  }
}

export default new ScheduledWorkflows();
